import { useCallback } from 'react';

const useScrollTo = (
  reference: React.RefObject<
    HTMLDivElement | HTMLButtonElement | HTMLImageElement | null
  >
): (() => void) => {
  const executeScroll = useCallback(
    () => reference?.current?.scrollIntoView({ behavior: 'smooth' }),
    [reference]
  );

  return executeScroll;
};

export default useScrollTo;
